import React from 'react';
import { Typography, MenuList, MenuItem, ListItemIcon } from '@material-ui/core';
import AddTabIcon from 'assets/icons/add-tab.svg';
import EditIcon from '@material-ui/icons/Edit';
import classes from './Menu.module.scss';

const MENUS = [
  {
    icon: <img src={AddTabIcon} alt='add-tab' />,
    label: 'New tab',
    action: 'new-tab',
  },
  {
    icon: <EditIcon style={{ color: '#4E5A71' }} />,
    label: 'Edit tab',
    action: 'edit-tab',
  },
];
const DocumentMenu = ({ menus = MENUS, onClickMenuItem }) => {
  return (
    <MenuList className={classes.menu}>
      {menus.map(({ action, icon, label }) => (
        <MenuItem
          key={action}
          onClick={() => {
            onClickMenuItem(action);
          }}>
          <ListItemIcon
            style={{
              minWidth: 32,
            }}>
            {icon}
          </ListItemIcon>
          <Typography className={classes.typography}>{label}</Typography>
        </MenuItem>
      ))}
    </MenuList>
  );
};
DocumentMenu.Item = React.forwardRef(({ action, onClickMenuItem, icon, label, ...props }, ref) => {
  return (
    <MenuItem
      ref={ref}
      {...props}
      key={action}
      onClick={(event) => {
        event.preventDefault();
        onClickMenuItem(action);
      }}>
      <ListItemIcon
        style={{
          minWidth: 32,
        }}>
        {icon}
      </ListItemIcon>
      <Typography className={classes.typography}>{label}</Typography>
    </MenuItem>
  );
});
export default DocumentMenu;
